export default class CustomTransforms {

    chunk(array, size) {
        const chunked_arr = [];
        let copied = [...array]; // ES6 destructuring
        const numOfChild = Math.ceil(copied.length / size); // Round up to the nearest integer
        for (let i = 0; i < numOfChild; i++) {
            chunked_arr.push(copied.splice(0, size));
        }
        return chunked_arr;
    }

    toggleItemOnArray(array, value) {
        const index = array.indexOf(value);

        if (index === -1) {
            array.push(value);
        } else {
            array.splice(index, 1);
        }

        return array;
    }

    mostFrequentItemInArray(array) {
        let result,
            best = -1,
            lookup = {};
        for (let i = 0; i < array.length; i++) {
            if (lookup[array[i]] == undefined) {
                lookup[array[i]] = 0;
            }
            lookup[array[i]]++;
            if (lookup[array[i]] > best) {
                best = lookup[array[i]];
                result = array[i]
            }
        }
        return result;
    }
}



// WEBPACK FOOTER //
// ./resources/site/js/providers/transforms.js